import { useTranslation } from 'react-i18next';
import { Lightbulb } from 'lucide-react';
import { PrefSection, type PrefVariant } from '@/components/PrefSection';
import { useShowKeyFindings } from '@/hooks/useShowKeyFindings';
import { cn } from '@/lib/utils';

/**
 * Toggle for the Key findings card on the patient Summary. Off by default;
 * saved per-device like the theme / font / thumbnail prefs.
 */
export const KeyFindingsToggle = ({ variant = 'card' }: { variant?: PrefVariant }) => {
  const { t } = useTranslation();
  const [show, setShow] = useShowKeyFindings();

  const toggle = (
    <button
      type="button"
      role="switch"
      aria-checked={show}
      aria-label={t('Show Key findings')}
      onClick={() => setShow(!show)}
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
        show ? 'bg-primary' : 'bg-muted-foreground/30',
      )}
    >
      <span
        className={cn(
          'inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform',
          show ? 'translate-x-[1.375rem]' : 'translate-x-0.5',
        )}
      />
    </button>
  );

  return (
    <PrefSection
      variant={variant}
      icon={Lightbulb}
      title={t('Show Key findings')}
      description={t(
        'Show the rule-based Key findings card at the top of the patient Summary (what is going well, what to watch, what to try next). Saved to this browser.',
      )}
      action={toggle}
    />
  );
};
